import { obfuscateObject, objectToQueryString } from "@/utils/utils"
import chinaImage from "@/assets/images/china_consultant.png"
import malaysiaImage from "@/assets/images/malaysia_consultant.png"
import aminImage from "@/assets/images/team/Amin.png"
import yizhengrongImage from "@/assets/images/Yizhengrong.jpg"
import customer1 from "@/assets/images/publication/customer2.png"
import customer2 from "@/assets/images/publication/zhende.png"
import customer3 from "@/assets/images/publication/customer1_3.png"
import customer4 from "@/assets/images/publication/customer1_4.png"
import customer5 from "@/assets/images/publication/fortune.png"
import customer6 from "@/assets/images/publication/logo-ec--en.png"
import customer7 from "@/assets/images/publication/customer1_7.png"
import customer8 from "@/assets/images/publication/customer1_8.png"
import customer9 from "@/assets/images/publication/customer1_9.png"
import customer10 from "@/assets/images/publication/customer1_10.png"
import customer11 from "@/assets/images/publication/customer1_11.png"
import customer12 from "@/assets/images/publication/customer1_12.png"
import customer13 from "@/assets/images/publication/customer1_13.png";
import customer14 from "@/assets/images/publication/customer1_14.png"
import customer21 from "@/assets/images/publication/customer2_1.png"
import customer22 from "@/assets/images/publication/customer2_2.png"
import customer23 from "@/assets/images/publication/customer2_3.png"
import customer24 from "@/assets/images/publication/customer2_4.png"
import customer25 from "@/assets/images/publication/customer2_5.png"
import customer26 from "@/assets/images/publication/customer2_6.png"
import customer27 from "@/assets/images/publication/customer2_7.png"
import customer28 from "@/assets/images/publication/customer2_8.png"
import customer29 from "@/assets/images/publication/customer2_9.png"
import customer30 from "@/assets/images/publication/customer2_10.png"
import customer31 from "@/assets/images/publication/customer2_11.png"
import customer32 from "@/assets/images/publication/customer2_12.png"
import customer33 from "@/assets/images/publication/customer2_13.png"
import customer34 from "@/assets/images/publication/customer2_14.png"
import customer35 from "@/assets/images/publication/customer2_15.png"

export const pageSearchTitle = "Check if your journal code is integrated?"
export const pageSearchPlaceholder = "Search ISSN or Journal name"

export const NODATA_PAGE_NAME = 'none'
export const DATA_PAGE_NAME = 'joint'

export const noDataSteps = [
    {
        title: "Find your Journal",
        description: "First, find the journal where you need to install the plugin",
        video: '',
    },
    {
        title: "Request Code and Application",
        description: "Apply for your journal plugin code, copy and paste the code onto the designated page",
        video: '',
    },
    {
        title: "Code Installation Completed",
        description: "Check the installation effect of plugins",
        video: '',
    }
]

export const dataTable = [
    {
        journalName: "West Kazakhstan Medical Journal",
        issn: "ISSN: 2707-6180 (Print) 2707-6199 (Online)",
    },
    {
        journalName: "West Kazakhstan Medical Journal",
        issn: "ISSN: 2707-6180 (Print) 2707-6199 (Online)",
    },
    {
        journalName: "West Kazakhstan Medical Journal",
        issn: "ISSN: 2707-6180 (Print) 2707-6199 (Online)",
    },
    {
        journalName: "West Kazakhstan Medical Journal",
        issn: "ISSN: 2707-6180 (Print) 2707-6199 (Online)",
    }
]

export const MC = ['Southeast Asia', 'China', 'Middle East', 'Central Asia']

export const onsultantObj = {
    'Southeast Asia': {
        name: "PROF. Muhammad Aqeel Ashraf",
        rank: "Senior Consultant",
        rightTitle: "Southeast Asia-Speaking Sales",
        rightSupport: "Southeast Asia Speaking Sales Support:",
        email: "contact@contrimetric.com",
        image: malaysiaImage
    },
    'China': {
        name: "Kristine GUO",
        rank: "Senior Consultant",
        rightTitle: "China-Speaking Sales",
        rightSupport: "China Speaking Sales Support:",
        email: "kristineguo@contrimetric.com",
        image: chinaImage
    },
    'Middle East': {
        name: "Dr.Amin D. Malayeri",
        rank: "Senior Consultant",
        rightTitle: "Middle East-Speaking Sales",
        rightSupport: "Middle East Speaking Sales Support:",
        email: "amin.daneshmand@contrimetric.com",
        image: aminImage
    },
    'Central Asia': {
        name: "Ilyosbek Boltaboev",
        rank: "Senior Consultant",
        rightTitle: "Central Asia-Speaking Sales",
        rightSupport: "Central Asia Speaking Sales Support:",
        email: "ilyosbekboltaboev19@icloud.com",
        image: yizhengrongImage
    }
}

export const countriesList = [
    "China", "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
    "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain",
    "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia",
    "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso",
    "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic",
    "Chad", "Chile", "Colombia", "Comoros", "Congo, Democratic Republic of the",
    "Congo, Republic of the", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
    "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
    "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland",
    "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada",
    "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary",
    "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
    "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North",
    "Korea, South", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon",
    "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar",
    "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
    "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro",
    "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
    "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia", "Norway", "Oman",
    "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru",
    "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis",
    "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe",
    "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia",
    "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka",
    "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",
    "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey",
    "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",
    "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
    "Yemen", "Zambia", "Zimbabwe", "Other"
];

export const SEARCHLETTER = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

export const dealRouterPath = (path, total, router, params) => {
    const jsonString = objectToQueryString(obfuscateObject(params))

    if (path === `/${NODATA_PAGE_NAME}` && total === 0) {
        return;
    }

    if (path === `/${NODATA_PAGE_NAME}` && total > 0) {
        router.push(`/${DATA_PAGE_NAME}?${jsonString}`);
    }

    if (path === `/${DATA_PAGE_NAME}` && total === 0) {
        router.push(`/${NODATA_PAGE_NAME}`);
    }


    if (path === `/${DATA_PAGE_NAME}` && total > 0) {
        router.push(`/${DATA_PAGE_NAME}?${jsonString}`);
    }

    if (path !== `/${NODATA_PAGE_NAME}` && path !== `/${DATA_PAGE_NAME}` && total === 0) {
        router.push(`/${NODATA_PAGE_NAME}`);
    }

    if (path !== `/${NODATA_PAGE_NAME}` && path !== `/${DATA_PAGE_NAME}` && total > 0) {
        router.push(`/${DATA_PAGE_NAME}?${jsonString}`);
    }
}

export const wosOfPubList = [
    {
        link: "https://www.discovmed.com/EN/home",
        pubImg: require("@/assets/images/publication/pub_1.png"),
        wosImg: require("@/assets/images/publication/pub_of.png"),
        pubPlusImg: require("@/assets/images/publication/pub_plus_1.png"),
    },
    {
        link: "https://revistatyca.org.mx/index.php/tyca/",
        pubImg: require("@/assets/images/publication/tycda.png"),
    },
    {
        link: "https://www.ecmjournal.org/",
        pubImg: require("@/assets/images/publication/ecm.png"),
    }, {
        link: "https://repqj.com/index.php/repqj",
        pubImg: require("@/assets/images/publication/repqj.png"),
    },
    {
        link: "https://www.ijmerr.com/",
        pubImg: require("@/assets/images/publication/ijmerr.png"),
    }
    // {
    //     link: "https://kneopen.com/journal/dmj/",
    //     pubImg: require("@/assets/images/publication/pub_2.png"),
    //     wosImg: require("@/assets/images/publication/pub_of.png"),
    //     pubPlusImg: require("@/assets/images/publication/pub_plus_2-4.png"),
    // },
    // {
    //     link: "https://kneopen.com/journal/ijrm/",
    //     pubImg: require("@/assets/images/publication/pub_3.png"),
    //     wosImg: require("@/assets/images/publication/pub_of.png"),
    //     pubPlusImg: require("@/assets/images/publication/pub_plus_2-4.png"),
    // },
    // {
    //     link: "https://kneopen.com/journal/jovr/",
    //     pubImg: require("@/assets/images/publication/pub_4.png"),
    //     wosImg: require("@/assets/images/publication/pub_of.png"),
    //     pubPlusImg: require("@/assets/images/publication/pub_plus_2-4.png"),
    // },
]

export const partmersJournalList = [
    {
        image: customer3,
        link: "https://www.discovmed.com",
        text: "Discovery Medicine"
    },
    {
        image: customer8,
        link: "https://revistatyca.org.mx/index.php/tyca",
        text: "Tecnología y Ciencias del Agua"
    },
    {
        image: customer22,
        link: "https://www.ecmjournal.org",
        text: "European Cells & Materials"
    },
    {
        image: customer21,
        link: "https://www.ijmerr.com",
        text: "International Journal of Mechanical Engineering and Robotics Research"
    },
    {
        image: customer23,
        link: "https://rcommunicationr.org/index.php/rcr",
        text: "Review of Communication Research"
    },
    {
        image: customer24,
        link: "https://cadernosdedereitoactual.es/index.php/cadernos",
        text: "Cadernos de Dereito Actual"
    },
    {
        image: customer25,
        link: "https://www.maxapress.com/emst",
        text: "Emergency Management Science and Technology",
        class: "is_journal"
    },
    {
        image: customer12,
        link: "https://ijwph.ir/browse.php?sid=3&slc_lang=en",
        text: "Iranian Journal of War and Public Health"
    },
    {
        image: customer35,
        link: "https://journal.ump.edu.my/ijame",
        text: "International Journal of Automotive and Mechanical Engineering",
        class: "is_journal"
    },
]

export const partmersPublisherList = [
    {
        image: customer26,
        link: "https://www.accscience.com",
        text: "AccScience Publishing"
    },
    {
        image: customer1,
        link: "https://www.zibelinepub.com",
        text: "Zibeline International Publishing"
    },
    {
        image: customer5,
        link: "https://www.fortunejournals.com",
        text: "Fortune Journals"
    },
    {
        image: customer2,
        link: "https://zdscience.com",
        text: "Zhende Publishing Limited"
    },
    {
        image: customer9,
        link: "https://www.etpub.com",
        text: "Engineering and Technology Publishing"
    },
    {
        image: customer12,
        link: "https://daneshafarand.org",
        text: "Afarand Scholarly Publishing Institute"
    },
    {
        image: customer13,
        link: "https://turbanpress.com",
        text: "Red Flower Publications"
    },
    {
        image: customer14,
        link: "https://reapress.com/collection",
        text: "Research Expansion Alliance (REA)"
    },
    {
        image: customer27,
        link: "https://cbptapp.cnki.net/findcb",
        text: "China National Knowledge Infrastructure"
    },
]

export const universitiesList = [
    {
        image: customer28,
        link: "https://www.scu.edu.cn/",
        text: "Sichuan University"
    },
    {
        image: customer29,
        link: "https://www.jlu.edu.cn/",
        text: "Jilin University"
    },
    {
        image: customer30,
        link: "https://xysm.csu.edu.cn/",
        text: "Xiangya School of Medicine"
    },
    {
        image: customer31,
        link: "https://www.csu.edu.cn/",
        text: "Central South University"
    },
    {
        image: customer33,
        link: "https://www.pumc.edu.cn/",
        text: "Peking Union Medical College"
    },
    {
        image: customer34,
        link: "https://www.smu.edu.cn/",
        text: "Southern Medical University"
    },
    {
        image: customer32,
        link: "https://www.shou.edu.cn/",
        text: "Shanghai Ocean University"
    },
    {
        image: customer6,
        link: "https://repqj.com",
        text: "European Association for the Development of Renewable Energies, Environment and Power Quality"
    },
    {
        image: customer11,
        link: "https://www.umpsa.edu.my/en",
        text: "Universiti Malaysia Pahang Al-Sultan Abdullah"
    }
]